import { render, staticRenderFns } from "./DocumentContract.vue?vue&type=template&id=3aa0e0b8&scoped=true"
import script from "./DocumentContract.vue?vue&type=script&lang=js"
export * from "./DocumentContract.vue?vue&type=script&lang=js"
import style0 from "./DocumentContract.vue?vue&type=style&index=0&id=3aa0e0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa0e0b8",
  null
  
)

export default component.exports